import { Injectable } from '@angular/core';
import Dexie, { Table } from 'dexie';

export interface TranslationEntry {
  module: string;
  data: any[];
  timestamp: number;
}

/**
 * Dexie-based IndexedDB service for persisting translation data.
 * Replaces localStorage for translation storage — no 5MB limit,
 * async I/O that doesn't block the main thread.
 */
@Injectable({
  providedIn: 'root'
})
export class TranslationDbService extends Dexie {
  translations!: Table<TranslationEntry, string>;

  constructor() {
    super('TranslationsDatabase');
    this.version(1).stores({
      translations: 'module'
    });
  }

  /**
   * Store all modules from the API response in a single transaction.
   */
  async bulkStoreModules(response: Record<string, any[]>): Promise<void> {
    const entries: TranslationEntry[] = [];
    const timestamp = Date.now();

    for (const [moduleName, data] of Object.entries(response)) {
      if (data) {
        entries.push({ module: moduleName, data, timestamp });
      }
    }

    await this.translations.bulkPut(entries);
  }

  /**
   * Retrieve all stored translation modules.
   */
  async getAllModules(): Promise<TranslationEntry[]> {
    return this.translations.toArray();
  }

  /**
   * Clear all stored translations.
   */
  async clearAll(): Promise<void> {
    await this.translations.clear();
  }
}
